import { ConfirmModal } from "./ConfirmModal";
import { translateWithFallback as t } from "./translateWithFallback";

type LeaveManualModalProps = {
    isOpen: boolean;
    domainCount: number;
    onStay: () => void;
    onLeave: () => void;
};

export const LeaveManualModal = ({ isOpen, domainCount, onStay, onLeave }: LeaveManualModalProps) => (
    <ConfirmModal
        isOpen={isOpen}
        dataAutomationPrefix="market-builder-v2-leave-manual"
        title={t("market.builder.v2.leaveManual.title", "Leave the manual creation?")}
        body={t(
            "market.builder.v2.leaveManual.body",
            `You have already selected ${domainCount} domains and by switching to agent, you will lose them.`,
            { count: domainCount },
        )}
        dismissLabel={t("market.builder.v2.leaveManual.stay", "Stay in this")}
        confirmLabel={t("market.builder.v2.leaveManual.leave", "Yes, leave without saving")}
        onDismiss={onStay}
        onConfirm={onLeave}
    />
);
